import React from 'react';

import ImageSizes from '../../config/images/imageSizes';

export interface ImageIconProps {
  /**
   * Image source (Url).
   */
  src: string;
  /**
   * A11Y: Image alt description (for screen readers).
   */
  alt: string;
  /**
   * Icon Size (small, medium or large).
   */
  size?: 'small' | 'medium' | 'large';
}

const imageWidthAndHeight = {
  small: ImageSizes.smallIcon.measures,
  medium: ImageSizes.mediumIcon.measures,
  large: ImageSizes.largeIcon.measures,
};

/**
 * Component that renders an image with the proper icon size
 */
const ImageIcon: React.FC<ImageIconProps> = (props: ImageIconProps) => {
  const { src, alt, size } = props;
  return <img {...imageWidthAndHeight[size]} src={src} alt={alt} />;
};

ImageIcon.defaultProps = {
  size: 'large',
};

export default ImageIcon;
